 <template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Bài viết</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col>
                                <b-form-group label="Bài viết:"
                                              label-for="input-name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-input type="text" class="col-6" id="input-name" v-model="searchForm.str" placeholder="Nhập tên hoặc mã ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            selectable
                            dataUrl="master-data/blogs"
                            gridName="Danh sách Bài viết"
                            ref="blogTable">
                        <template v-slot:actions>
                            <router-link v-if="authorize(['ManageBlog'])" to="/master-data/blogs/create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <b-button v-if="authorize(['ManageBlog'])" size="md" @click.stop="deletes" variant="danger" :disabled="isDisabledDelete">
                                Xóa
                            </b-button>
                        </template>
                        <template v-slot:cell(status)="row">
                            <b-form-checkbox v-model="row.value" @change="updateStatus(row.item, $event)"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewBlog'])" size="sm" :to="{ path: `./detail/${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template>
                                    <b-button v-if="authorize(['ManageBlog'])" size="sm" :to="{ path: `./edit/${row.item.id}` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button v-if="authorize(['ManageBlog'])" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { authorizationMixin } from '@/shared/mixins'

    export default {
        name: 'ListUnitType',
        mixins: [authorizationMixin],
        data() {
            return {
                searchForm: {
                    str: null
                },
                isDisabledDelete: true,
                gridOptions: {
                    fields: [
                        { key: 'blogCategoryName', label: 'Danh mục bài viết', sortable: true, sortDirection: 'asc' },
                        { key: 'title', label: 'Tiêu đề bài viết', sortable: true, sortDirection: 'asc' },
                        // { key: 'metaTitle', label: 'Tiêu đề của trang', sortable: true, sortDirection: 'asc' },
                        // { key: 'metaKeywords', label: 'Key của trang', sortable: true, sortDirection: 'asc' },
                        // { key: 'metaDescriptions', label: 'Mô tả của trang', sortable: true, sortDirection: 'asc' },
                        { key: 'displayOrder', label: 'Vị trí hiển thị', sortable: true, sortDirection: 'asc' },
                        { key: 'status', label: 'Trạng thái', sortable: false },
                    ],
                    sortBy: 'id'
                },
            }
        },
        computed: {

        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.blogTable.selectedRows
                },
                (val) => {
                    this.isDisabledDelete = val.length == 0;
                }
            )
        },
        created() {
        },
        methods: {
            search() {
                this.$refs.blogTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;

                if (confirm('Bạn có chắc chắn muốn xóa Bài viết này?')) {
                    this.$services.delete(`master-data/blogs/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa Bài viết thành công');
                        vm.search();
                    });
                }
            },
            deletes() {
                var vm = this;
                var selectedRows = this.$refs.blogTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các Bài viết này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`master-data/blogs?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa Bài viết thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn Bài viết cần xóa');
                }
            },

            loadBlogCategoryDetail() {
                var vm = this;
                return this.$services.get(`master-data/blog-categories/${this.blogCategoryId}`).done(blogCategory => {
                    vm.blogCategory = blogCategory;
                });
            },
        }
    }
</script>
<style scoped>
</style>
